export default "__VITE_ASSET__RMX_bMi1__"